import React from 'react';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { DefaultIcon, Poin as PoinIcon } from '../../../atoms/icons/index';

interface Props {
    title: string;
    desc: string;
    icon?: React.ReactElement<DefaultIcon> | undefined;
    id: string | number;
}

const Poin: React.FC<Props> = (props) => {
  const {
    title, desc, id, icon = <PoinIcon width={16} />,
  } = props;
  const navigate = useNavigate();
  return (
    <button type="button" className="card-poin-container" onClick={() => navigate(id.toString())}>
      <div className="poin-container">
        <div className="poin-title">{title}</div>
        <div className="poin">
          <div className={icon ? 'me-2' : 'd-none'}>{icon}</div>
          <div className="poin-desc">{desc}</div>
        </div>
      </div>
    </button>
  );
};

export default Poin;
